import { FORWARDING_RULE_ALGORITHM, ROUTE } from 'constant';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';

export default ({ history }) => {
  const { [ACTIONS_TYPES.TARGET_GROUP.GET_ALL]: targetGroups = [] } = useSelector((e) => e);
  useEffect(() => {
    actions.targetGroup.getAll();
  }, []);

  return (
    <Shared.widgets.Page route={ROUTE.DASHBOARD.TARGET_GROUPS} isStrap={false}>
      <Shared.widgets.Section
        items={targetGroups}
        sectionTitle="Target Groups"
        setItemTitle={({ properties = {} }) => properties.name}
        setItemDetails={({ properties = {} }) => (
          <>
            <span>{properties.protocol}</span>
            <Shared.utilities.Separator />
            <span>{(FORWARDING_RULE_ALGORITHM[properties.algorithm] || {}).label}</span>
          </>
        )}
        itemIcon="bullseye"
        onCreateClick={() => history.push(ROUTE.DASHBOARD.TARGET_GROUPS_CREATE.path.replace(':id', 'create'))}
        itemOnClick={({ id }) => history.push(ROUTE.DASHBOARD.TARGET_GROUP.path.replace(':id', id))}
      />
    </Shared.widgets.Page>
  );
};
